export default __webpack_public_path__ + "static/media/solution-nre.fe739207.svg";